import React from 'react';
import {
  Paper,
  Typography,
  Card,
  CardHeader,
  CardMedia,
  CardActionArea,
  Box
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import Markdown from './components/Markdown';

import {
  useHistory,
  useRouteMatch,
  Route,
  Redirect,
} from 'react-router-dom';

import slugify from 'slugify';

import DalabGrid from './components/DalabGrid';

import { openInNewTab } from './utils';

export const current_people = [
  {
    name: 'Thomas Hofmann',
    role: 'Professor',
    image: 'images/people/ThomasHofmann/photo.jpg',
    email: 'hc.zhte.fni@nnamfoh.samoht',
    room: 'CAB F 48.1',
    address: 'Universitätstrasse 6, 8092 Zürich, Switzerland',
    markdown: `

##  News
My new arXiv paper studies non-linear effects in learning dynamics induced by finite step sizes. It analyzes a deceptively simple, canonical low-dimensional system with analytical tools and shows how this nucleus persists in more realistic networks.

**[The Map Behind the Flow: Finite-Step Gradient Descent as a Dynamical System](http://arxiv.org/abs/2607.04993)**

We have also finished a long paper on discrete diffusion models, showing that they fundamentally learn the oracle reverse jump-rate field of the underlying Continuous Time Markov Chain. Denoisers, score ratios, and bridge plug-in predictors are mathematically equivalent coordinate representations of the same object, whose exact characterization follows from a CTMC ELBO identity that decomposes into data entropy plus reverse-path KL. 

**[What Does a Discrete Diffusion Model Learn?](http://arxiv.org/abs/2607.05381)**

##  Curriculum Vitae
1997 Ph.D. Computer Science, University of Bonn 

1997-1999 Postdoctoral Fellow, MIT and UC Berkeley 

1999-2004 Assistant/Associate Professor for Computer Science, Brown University 

2001-2015 Co-founder, Chief Scientist, Recommind.com (now OpenText) 

2004-2006 Professor for Computer Science, Technical University of Darmstadt 

2004-2005 Director, Fraunhofer IPSI 

2006-2013 Director of Engineering and co-site Lead, Google Zurich 

2014-2023 Co-founder and CTO, [1plusX](http://www.1plusx.com) (now TripleLift)

2014-today Professor, Department of Computer Science, ETH Zürich
`
  },
  {
    name: 'Paulina Motyka',
    role: 'Administrative Assistant',
    image: 'images/people/PaulinaMotyka/image.jpg',
  },
  {
    name: 'Tiago Pimentel',
    role: 'PostDoc',
    image: 'images/people/TiagoPimentel/photo.jpg',
    markdown: `I am interested in understanding how humans and machines process language. To this end, I work on interpretability and analysis of language models, and on psycholinguistics.`
  },
  {
    name: 'Amir Joudaki',
    role: 'PostDoc',
    image: 'images/people/Amir.png',
    markdown: `
My research is primarily focused on a mathematical understanding of deep nonlinear neural networks, namely the how nonlinearity and depth interact and affect the training dynamics. 

During my MSc and PhD, I worked on mathematical understanding of deep neural nets and biomedical applications of AI, also at ETH Zurich. 

Before, I did a masters in Cognitive Neuroscience at SISSA, Italy, and a BSc in computer engineering in Sharif University, Iran.
`
  },
  {
    name: 'Javad Parsa',
    role: 'Visiting PostDoc',
    image: 'images/people/JavadParsa/photo.jpg',
    externalUrl: 'https://javadparsa.github.io/',
  },
  {
    name: 'Giulia Lanzillotta',
    role: 'PhD Student, AI Center PhD Fellow',
    image: 'images/people/LanzillottaGiulia/photo.jpg',
    markdown: `I am a third+ year PhD student in the Data Analytics Lab and at the ETH AI Center. I work on Deep Continual Learning from a theoretical perspective, especially focusing on optimization. 
See [my personal blog](https://giulialanzillotta.github.io/giulias_blog/about/) for more recent info. `
  },
  {
    name: "Yuhui Ding",
    role: "PhD Student",
    image: "images/people/YuhuiDing/photo.jpg",
    markdown: `
I am a PhD student advised by Prof. Thomas Hofmann. I have broad interests in representation learning and optimization for neural networks.
For more information, please check my personal website: https://skeletondyh.github.io/
    `
  },
  {
    name: 'Nodens Koren',
    role: 'PhD Student',
    image: 'images/people/NodensKoren/photo.jpg',
    markdown: `I am a PhD student in the GW-Learn project at ETH Zürich, working in the Data Analytics Lab under the supervision of Prof. Thomas Hofmann. Prior to joining the Data Analytics Lab, I obtained my Bachelor's degree in computer engineering from the University of Illinois at Urbana-Champaign, followed by my Master's degree in computer science from the University of Melbourne.

My research primarily revolves around enhancing the robustness of deep learning models and their application in AI4Science. For a comprehensive list of my publications, please refer to [Google Scholar](https://scholar.google.com/citations?user=4JdmvGoAAAAJ).`
  },
  {
    name: "Enis Simsar",
    role: "PhD Student",
    image: "images/people/EnisSimsar/photo.jpg",
    markdown: `I am a Ph.D. student in the Data Analytics Lab. I received my Informatics Master's degree from Technical University of Munich and B.Sc. in Computer Engineering from Bogazici University, Istanbul.

I have a keen interest in Computer Vision and Natural Language Processing, with a particular focus on image generation and editing using generative adversarial networks, diffusion models and neural radiance fields. If you're interested, you can take a look at my personal website: https://enis.dev and [Google Scholar](https://scholar.google.com/citations?user=xDvFUb4AAAAJ&hl=en).`
  },
  {
    name: 'Aleksandar Terzić',
    role: 'External PhD Student',
    image: 'images/people/AleksandarTerzic/photo.jpg',
    externalUrl: 'https://research.ibm.com/people/aleksandar-terzic--2',
  },
  {
    name: 'Shlomo Libo',
    role: 'PhD Student (currently at the ELLIS Institute Tübingen)',
    image: 'images/people/ShlomoLibo/photo.png',
    externalUrl: 'https://shlomolibo.github.io/',
  },
  {
    name: 'Rodrigo Casado',
    role: 'PhD Student',
    image: 'images/people/RodrigoCasado/photo.jpg',
    markdown: `I am a PhD student co-supervised by Thomas Hofmann and Bernhard Schölkopf as part of the Max Planck ETH Center for Learning Systems program. My research interests lie at the intersection between deep learning, generative modeling, and mathematics, currently working on discrete diffusion and reasoning tasks. For more information, you can check my personal website: https://rodcasnog.github.io/`
  },
  {
    name: 'Felix Sarnthein',
    role: 'PhD Student',
    image: 'images/people/FelixSarnthein/photo.jpg',
    markdown: `I am a PhD student within the Max Planck ETH Center for Learning Systems (CLS) advised by Antonio Orvieto (MPI) and Thomas Hofmann. I am generally fascinated by the learning dynamics of neural networks and the interaction of parameterization, initialization, objective, and optimization in deep learning. In particular, I'm interested in potentially self-supervised methods for long-range modeling and hierarchical feature learning of sequential data.
    
For more information, please check my personal website: https://safelix.github.io/`
  },
];

export const alumni = [
  {
    name: 'Lorenzo Noci',
    role: 'Member of Technical Staff, OpenAI',
    image: 'images/people/LorenzoNoci/photo.jpg',
    externalUrl: 'https://scholar.google.com/citations?user=VZ__1r0AAAAJ&hl=en',
  },
  {
    name: 'Weronika Ormaniec',
    role: 'Former PhD Student',
    image: 'images/people/Weronika/photo.jpg',
  },
  {
    name: 'Dimitri von Rütte',
    role: 'Former PhD Student',
    image: 'images/people/Dimitri/photo.jpg',
  },
  {
    name: 'Piera Riccio',
    role: 'PostDoc, MultiX @ UvA Informatics Institute, Amsterdam',
    image: 'images/people/PieraRiccio/photo.jpg',
    externalUrl: 'https://multix.io/',
  },
  {
    name: 'Sotiris Anagnostidis',
    role: 'Member of Technical Staff, Anthropic',
    image: 'images/people/SotirisAnagnostidis/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/sotiris-anagnostidis-b064a5129/',
  },
  {
    name: 'Sidak Pal Singh',
    role: 'Research Scientist, Google DeepMind',
    image: 'images/people/SidakPalSingh/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/sidakpalsingh/',
  },
  {
    name: 'Gregor Bachmann',
    role: 'Machine Learning Researcher, Apple',
    image: 'images/people/GregorBachmann/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/gregor-bachmann-27a728180/',
  },
  {
    name: 'Bobby He',
    role: 'Member of Technical Staff, Anthropic',
    image: 'images/people/BobbyHe/photo.jpg',
    externalUrl: 'https://uk.linkedin.com/in/bobby-he-5022a28b',
  },
  {
    name: 'Janis Fluri',
    role: 'AI Research Engineer, kapa.ai',
    image: 'images/people/JanisFluri/photo.jpg',
    externalUrl: 'https://ch.linkedin.com/in/janis-fluri-053563203'
  },
  {
    name: 'Dario Miro Konopatzki',
    role: 'Former PhD Student',
    image: 'images/people/placeholder.jpg',
    externalUrl: 'https://github.com/dariokonopatzki'
  },
  {
    name: 'Antonio Orvieto',
    role: 'Principal Investigator, ELLIS Institute Tübingen',
    image: 'images/people/AntonioOrvieto/photo.jpg',
  },
  {
    name: 'Dario Pavllo',
    role: 'Deep Learning Engineer, QuantCo',
    image: 'images/people/DarioPavllo/photo.jpg',
    externalUrl: `https://ch.linkedin.com/in/dario-pavllo`
  },
  {
    name: 'Luca Biggio',
    role: 'Postdoctoral Research Fellow, EPFL',
    image: 'images/people/LucaBiggio/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/luca-biggio/?originalSubdomain=it'
  },
  {
    name: 'Seyed-Mohsen Moosavi-Dezfooli',
    role: 'Machine Learning Researcher, Apple',
    image: 'images/people/SeyedMohsenMoosaviDezfooli/photo.jpg',
    externalUrl: 'https://smoosavi.me/'
  },
  {
    name: 'Jonas Kohler',
    role: 'Researcher/Engineer, Meta',
    image: 'images/people/JonasKohler/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/jonasmoritzkohler/?originalSubdomain=ch'
  },
  {
    name: 'Giambattista Parascandolo',
    role: 'Research Scientist, OpenAI',
    image: 'images/people/GiambattistaParascandolo/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/giambattista-parascandolo-216787a4/'
  },
  {
    name: 'Aurelien Lucchi',
    role: 'Faculty, University of Basel',
    image: 'images/people/AurelienLucchi/photo.jpg',
    externalUrl: 'https://omls.dmi.unibas.ch/en/persons/aurelien-lucchi/'
  },
  {
    name: 'Paulina Grnarova',
    role: 'CEO, Co-Founder, DeepJudge',
    image: 'images/people/PaulinaGrnarova/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/paulinagrnarova'
  },
  {
    name: 'Yannic Kilcher',
    role: 'CTO, Co-Founder, DeepJudge',
    image: 'images/people/YannicKilcher/photo.jpg',
    externalUrl: 'https://ykilcher.com',
  },
  {
    name: 'Kevin Roth',
    role: 'Chief Data Scientist, Co-Founder, DeepJudge',
    image: 'images/people/KevinRoth/photo.jpeg',
    externalUrl: 'https://www.linkedin.com/in/kevinsroth/'
  },
  {
    name: 'Leonard Adolphs',
    role: 'Deep Learning Engineer, QuantCo',
    image: 'images/people/LeonardAdolphs/Passbild-1.png',
    externalUrl: `https://leox1v.com/`
  },
  {
    name: 'Hadi Daneshmand',
    role: 'Postdoctoral Research Fellow, Princeton',
    image: 'images/people/HadiDaneshmand/photo.jpg',
    externalUrl: 'https://ece.princeton.edu/people/hadi-daneshmand'
  },
  {
    name: 'Gary Becigneul',
    role: 'CEO, Co-Founder, Gematria',
    image: 'images/people/GaryBecigneul/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/gary-b%C3%A9cigneul-phd-9b2bb0110/'
  },
  {
    name: 'Florian Schmidt',
    role: 'Head of Research, Co-Founder, DeepJudge',
    image: 'images/people/FlorianSchmidt/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/florian-schmidt-phd/'
  },
  {
    name: 'Celestine Mendler-Dünner',
    role: 'Principal Investigator, ELLIS Institute Tübingen',
    image: 'images/people/CelestineDuenner/photo.jpg',
    externalUrl: 'http://www.celestine.ai/'
  },
  {
    name: 'Octavian Ganea',
    role: 'Alumnus',
    image: 'images/people/OctavianGanea/photo.jpg',
    externalUrl: 'https://news.mit.edu/2022/remembering-octavian-eugen-ganea-0707'
  },
  {
    name: 'Martin Jaggi',
    role: 'Faculty, EPFL',
    image: 'images/people/MartinJaggi/photo.jpg',
    externalUrl: 'https://www.epfl.ch/labs/mlo/'
  },
  {
    name: 'Martin Kiefel',
    role: 'Senior Applied Scientist, Amazon',
    image: 'images/people/MartinKiefel/photo.jpg',
    externalUrl: 'https://www.linkedin.com/in/martin-kiefel-3762a9b/'
  },
  {
    name: 'Jason Lee',
    role: ' Senior Machine Learning Scientist, Tesla Autopilot',
    image: 'images/people/JasonLee/photo.jpg',
    externalUrl: 'https://jasonleeinf.github.io/'
  }
];


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
  },
  cardImage: {
    width: '13em',
    maxHeight: '11em',
    objectFit: 'contain',
    margin: '1em',
  },
  mainImage: {
    width: '13em',
    maxHeight: '11em',
    objectFit: 'contain',
  },
}));

current_people.map(p => p.slug = slugify(p.name, { remove: /[\s]/g }))
alumni.map(p => p.slug = slugify(p.name, { remove: /[\s]/g }))

function PeopleGrid() {
  const classes = useStyles();
  const history = useHistory();

  function goToPerson(person, alumni) {
    if (person.externalUrl) {
      openInNewTab(person.externalUrl);
    } else {
      if (alumni) {
        history.push(`/people/alumni/${person.slug}`);
      } else {
        history.push(`/people/${person.slug}`);
      }

    }
  }

  return (
    <>
      <DalabGrid data={current_people}>
        {(person) =>
          <Card>
            <CardActionArea onClick={() => goToPerson(person, false)}>
              <Box height='13em' display='flex' alignItems='flex-start' justifyContent='space-between'>
                <CardHeader title={person.name} subheader={person.role} />
                <CardMedia component='img' className={classes.cardImage} image={process.env.PUBLIC_URL + '/' + person.image} />
              </Box>
            </CardActionArea>
          </Card>
        }
      </DalabGrid>
      <hr />
      <DalabGrid data={alumni}>
        {(person) =>
          <Card>
            <CardActionArea onClick={() => goToPerson(person, true)}>
              <Box height='13em' display='flex' alignItems='flex-start' justifyContent='space-between'>
                <CardHeader title={person.name} subheader={person.role} />
                <CardMedia component='img' className={classes.cardImage} image={process.env.PUBLIC_URL + '/' + person.image} />
              </Box>
            </CardActionArea>
          </Card>
        }
      </DalabGrid>
    </>
  )
}

function Person({ person }) {
  const classes = useStyles();
  if (!person || person.externalUrl) return <Redirect to='/people' />
  const infoParts = [
    { title: 'E-Mail', prop: 'email', reverse: true },
    { title: 'Room', prop: 'room' },
    { title: 'Address', prop: 'address' },
    { title: 'Phone', prop: 'phone' },
  ]
  return (
    <>
      <Paper className={classes.paper}>
        <Box px={3} py={2}>
          <Typography variant='h4' gutterBottom>
            {person.name}
          </Typography>
          <Box display='flex' alignItems='flex-start' flexWrap='wrap' mb={4}>
            <img className={classes.mainImage} src={process.env.PUBLIC_URL + '/' + person.image} alt='portrait' />
            <Box mt='1em'>
              <Typography variant='subtitle1' gutterBottom>
                {person.role}
              </Typography>
              {infoParts.map(({ title, prop, reverse }, idx) => person[prop] &&
                <Box key={idx}>
                  <Typography style={{ fontWeight: 'bold' }} display='inline'>{title}:&nbsp;</Typography>
                  <Typography display='inline' className={reverse && 'text-reverse'}>{person[prop]}</Typography>
                </Box>
              )}
            </Box>
          </Box>
          {person.markdown && <Markdown>
            {person.markdown}
          </Markdown>
          }
        </Box>
      </Paper>
    </>
  );
}

export default function () {
  const match = useRouteMatch();
  return (
    <>
      <Route exact path={match.path} component={PeopleGrid} />
      <Route exact path={`${match.path}/alumni/:slug`} render={({ match }) =>
        <Person person={alumni.find(p => p.slug === match.params.slug)} />
      } />
      <Route exact path={`${match.path}/:slug`} render={({ match }) =>
        <Person person={current_people.find(p => p.slug === match.params.slug)} />
      } />
    </>
  );
}
